// Database and concurrency (domain part). Mirrors lud-backend/errorCatalog/database.js.
const databaseMessages = {
  CONCURRENT_CHANGE: { en: "The account was changed at the same time. Please try again.", ar: "تم تعديل الحساب في الوقت نفسه. يرجى المحاولة مرة أخرى." },
};

export default databaseMessages;
